import { render } from "./TakeOutHome.vue?vue&type=template&id=05dc48d2&scoped=true"
import script from "./TakeOutHome.vue?vue&type=script&lang=js"
export * from "./TakeOutHome.vue?vue&type=script&lang=js"

import "./TakeOutHome.vue?vue&type=style&index=0&id=05dc48d2&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dc48d2"]])

export default __exports__